<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >
        <v-row>
          <v-col
            :lg="6"
            :md="6"
            :sm="6"
            class="pb-0"
          >
            <v-form
              ref="form"
              lazy-validation
              class="app-form"
              @submit.prevent="onSubmit"
            >
              <v-card
                class="app-card"
                elevation="0"
              >
                <v-card-title class="app-card-title">
                  <h4 class="text">
                    <span>
                      {{ isEditableRouter ? "Novo" : "Editar" }} Tipo Pedido
                    </span>
                  </h4>
                </v-card-title>
                <v-card-text class="app-card-content">                  
                  <v-row>
                    <v-col
                      :lg="12"
                      :md="12"
                      :sm="12"
                      class="pb-0"
                    >
                      <v-text-field
                        v-model="solicitationType.data.name"
                        outlined
                        dense
                        label="Nome *"
                        placeholder="Digite o nome"
                        :rules="[rules.required]"
                      />
                    </v-col>
                    <v-col
                      :lg="12"
                      :md="12"
                      :sm="12"
                      class="pb-0"
                    >
                      <v-text-field
                        v-model="solicitationType.data.key"
                        outlined
                        dense
                        label="Key *"
                        placeholder="Ex:. CADASTRO_EMPRESA"
                        :rules="[rules.required]"
                        :disabled="isEditableRouter()"
                      />
                    </v-col>
                    <v-col
                      :lg="12"
                      :md="12"
                      :sm="12"
                      class="pb-0"
                    >
                      <v-text-field
                        v-model="solicitationType.data.value"
                        outlined
                        dense
                        label="Valor *"
                        placeholder="Ex:. 10.90"
                        :rules="[rules.required]"
                        type="number"
                        min="0"
                      />
                    </v-col>
                  </v-row>                                       
                </v-card-text>
                <v-divider />
                <v-card-actions class="app-card-actions">
                  <span class="app-form__warning">
                    Atenção: Campos que possuem o
                    <em>*</em> são obrigatórios
                  </span>
                  <v-spacer />
                  <v-btn
                    depressed
                    outlined
                    color="error"
                    @click="$router.back()"
                  >
                    Voltar
                  </v-btn>
                  <v-btn
                    depressed
                    color="success"
                    type="submit"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
                <section
                  v-if="solicitationType.isLoading"
                  class="loading"
                >
                  <v-progress-circular
                    indeterminate
                    color="success"
                  />
                  <span>Enviando informações ...</span>
                </section>
              </v-card>
            </v-form>
          </v-col>
          <v-col
            :lg="6"
            :md="6"
            :sm="6"
            :xs="12"
          >
            <TypeSolicitationTypeDocumentList 
              v-if="solicitationType.data.id"
              :type-solicitation-id="solicitationType.data.id"
            />
          </v-col>  
        </v-row>       
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import TipoDocumento from '@/services/tipo-documento.service';
  import TypeSolicitationTypeDocumentList from './components/TypeSolicitationTypeDocumentList.vue';

  export default {
    components: {
      TypeSolicitationTypeDocumentList
    },

    data: () => ({      
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido'
      },    
    }),

    mounted() {      
      this.fetchSolicitationType();   
    },
    
    destroyed() {      
      this.clear();
    },

    computed: {
      ...mapState('tipoPedido', {
        solicitationType: state => state.detail
      }),
    },

    watch: {
      '$route.params.id'(newId, oldId) {      
        this.fetchSolicitationType();
      }
    },
    
    methods: {
      fetchSolicitationType() {
        if (!this.$route.params.id) return;

        this.show(this.$route.params.id);
      },

      onSubmit() {
        const isValid = this.$refs.form.validate();

        if (isValid) {
          if (this.isEditableRouter()) {
            this.update(this.solicitationType.data);
          } else {
            this.create(this.solicitationType.data);
          }
        }
      },

      isEditableRouter() {
        return this.$route.name === 'dashboard-tipo-pedido-editar';
      },

      ...mapActions('tipoPedido', { show: 'SHOW' }),
      ...mapActions('tipoPedido', { clear: 'CLEAR_DETAIL' }),
      ...mapActions('tipoPedido', { create: 'CREATE' }),
      ...mapActions('tipoPedido', { update: 'UPDATE' }),
    },
  };
</script>

<style lang="scss" scoped>
.title {
  margin: 0px;
  font-size: 15px !important;
  font-weight: bold !important;
}
</style>
